import axios from "../axios"

const menuApi = {
	addMenu(data) {
		return axios({
			url: `/api/Menu/CreateOrEdit`,
			method: "post",
			data
		})
	},
	
	deleteMenu(id) {
		return axios({
			url: `/api/Menu/Delete`,
			method: "post",
			params:{id}
		})
	},
	
	getMenuTree() {//查询所有菜单
		return axios({
			url: `/api/Menu/GetMenuTree`,
			method: "post",
		})
	},
	getUserMenuList() { //查询用户菜单
		return axios({
			url: `/api/Menu/GetUserMenuList`,
			method: "post",
		})
	},
	getUserMenuTree() { //查询用户菜单树
		return axios({
			url: `/api/Menu/GetUserMenuTree`,
			method: "post",
		})
	},

}
export default menuApi